import { useRef } from 'react';
import * as Comlink from 'comlink';
import type { CalculatorWorkerApi } from './calculator.worker';

// Worker is instantiated once per component tree and reused.
// Vite handles the `?worker` suffix → returns a Worker constructor.
export function useCalculatorWorker(): Comlink.Remote<CalculatorWorkerApi> {
  const workerRef = useRef<Comlink.Remote<CalculatorWorkerApi> | null>(null);

  if (!workerRef.current) {
    const worker = new Worker(
      new URL('./calculator.worker.ts', import.meta.url),
      { type: 'module' },
    );
    workerRef.current = Comlink.wrap<CalculatorWorkerApi>(worker);
  }

  return workerRef.current;
}
